const GA_ID = 'G-91235XJS7P';

const ga = (...args) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag(...args);
};

// Called when user scrolls into a new section
export const pageview = (path) => {
    ga('config', GA_ID, { page_path: path, module_type: 'marketing' });
};

// Demo request submitted successfully
export const trackDemoRequest = (institutionName) => {
    ga('event', 'demo_request', {
        event_category: 'conversion',
        event_label: institutionName,
    });
};

// Partnership application submitted successfully
export const trackPartnershipApplication = (institutionName) => {
    ga('event', 'partnership_application', {
        event_category: 'conversion',
        event_label: institutionName,
    });
};

// Contact form submitted successfully
export const trackContactSubmit = (institutionName) => {
    ga('event', 'contact_submit', {
        event_category: 'conversion',
        event_label: institutionName,
    });
};

// High-intent CTA clicks (Book a Demo, Apply for Partnership buttons)
export const trackCTAClick = (label) => {
    ga('event', 'cta_click', {
        event_category: 'engagement',
        event_label: label,
    });
};

// Fired once when user first interacts with a form (pre-conversion intent)
export const trackFormStart = (formName) => {
    ga('event', 'form_start', {
        event_category: 'conversion',
        event_label: formName,
    });
};

// Fired when form submission fails (API or validation error)
export const trackFormError = (formName, errorType) => {
    ga('event', 'form_submit_error', {
        event_category: 'engagement',
        event_label: formName,
        error_type: errorType,
    });
};

// Fired when any pricing plan CTA is clicked
export const trackPricingInterest = (planName) => {
    ga('event', 'pricing_plan_interest', {
        event_category: 'engagement',
        event_label: planName,
    });
};

// Fired when a FAQ item is opened (not closed)
export const trackFAQExpand = (question) => {
    ga('event', 'faq_expand', {
        event_category: 'engagement',
        // Truncate long questions to keep the event label clean in GA4
        event_label: question.length > 75 ? question.slice(0, 75) + '…' : question,
    });
};

// Fired on outbound link clicks (email, LinkedIn, X, etc.)
export const trackOutboundClick = (destination) => {
    ga('event', 'outbound_click', {
        event_category: 'engagement',
        event_label: destination,
    });
};

// Fired alongside pageview when user scrolls into a new section
// Gives us a named event (not just a pageview) for funnel reports in GA4
export const trackSectionView = (sectionId) => {
    ga('event', 'section_view', {
        event_category: 'engagement',
        event_label: sectionId,
    });
};
